// Shared Comm Prefs server-contract constants (GEIS-359). Kept in their own
// pure module — separate from `communication-preferences.api`, which wraps
// leagueFetch and is therefore fully mocked at the network boundary in tests.
// Constants must NOT live in that mocked module: consumers (e.g. the Settings
// mapper) read them at module-eval time and would otherwise resolve `undefined`
// under a network mock.

// Option name carrying a toggle's on/off state. Shared so the onboarding
// Paperless save (GEIS-500) builds the same `goPaperlessForAll` preference the
// Settings screen sends, without re-hardcoding the key.
export const TOGGLE_OPTION_NAME = 'enabled';

// Server preference id for the master "Go paperless for all" toggle (PRD S-5).
// Single source of truth for both the Settings screen mapping and the
// onboarding opt-in save (GEIS-500) — mirrors geisinger-ios sending
// `goPaperlessForAll` from the same resolver path.
export const GO_PAPERLESS_FOR_ALL_PREFERENCE_ID = 'goPaperlessForAll';

// Every preference the Go Paperless opt-in turns on: the master plus the
// "Benefits and plan documents" items it covers. Per S-5 the master is coupled
// to its children — "if a user turns on Go Paperless but then shifts any of the
// Benefits and Plan document toggles to OFF then Go Paperless should shift to
// OFF" — so Settings renders the master off unless the children are on too, and
// writing the master alone reads back as "not paperless". Premium Statements is
// deliberately excluded: S-5 only surfaces it to members who have them. Matches
// the sets geisinger-ios and geisinger-android send (GEIS-577 / GEIS-578).
export const PAPERLESS_PREFERENCE_IDS = [
  GO_PAPERLESS_FOR_ALL_PREFERENCE_ID,
  'explanationOfBenefits',
  'benefitsDocuments',
  'newsletters',
  'letters',
] as const;

// Option name carrying a contact field's value (phone / email), as opposed to
// the on/off `TOGGLE_OPTION_NAME` used by preference toggles.
export const CONTACT_OPTION_NAME = 'value';

// Server preference ids for the contact section. Shared so the onboarding
// Account Setup save (GEIS-500) writes the same ids the Settings Communication
// Preferences screen reads/writes.
export const CONTACT_PREFERENCE_IDS = {
  mobilePhone: 'mobilePhone',
  preferredPhone: 'preferredPhone',
  email: 'email',
} as const;

// Server preference ids for the "Promotions and incentives" section. Shared so
// the onboarding marketing-emails opt-in (GEIS-500) writes the same ids the
// Settings screen does — opting in sets the master + email channel on.
export const PROMOTIONS_PREFERENCE_IDS = {
  receiveUpdates: 'promoReceiveUpdates',
  email: 'promoEmail',
  sms: 'promoSms',
  phone: 'promoPhone',
} as const;
